// Shared bits for the wide analytics tables.
//
// Ant lays a table out at a minimum of 100% of its container even with
// `scroll.x` set, and the leftover width all lands on whichever column has no
// fixed `width`. On these pages that column is always a text column (Section,
// Question, Form), so it stretched across the row and pushed the value columns
// against the far right edge, a screen away from the label they belong to.
//
// The fix is to give every real column a width and append SPACER_COL, which
// takes the leftover instead so the data stays packed together on the left.
// It is borderless and transparent (see .pivot-spacer in index.css) so it reads
// as the table simply ending rather than as an empty column.
export const SPACER_COL = {
  title: '',
  key: '__spacer',
  className: 'pivot-spacer',
  onHeaderCell: () => ({ className: 'pivot-spacer' }),
  render: () => null,
};

// Height of the pinned title strip above a table that uses .sticky-table-card
// or .sticky-table-label. A Table's `sticky.offsetHeader` must match this
// exactly so its header stacks directly underneath rather than overlapping.
// Keep in step with those two rules in index.css.
export const STICKY_OFFSET = 40;

// A Table's scroll width: its columns' widths added up (grouped columns by
// their children; one with no width counts 150). With scroll x 'max-content'
// the browser sizes columns to their text and ignores the widths set on them,
// so a long question pushed every column after it off the screen.
export function scrollWidth(columns) {
  return (columns || []).reduce(
    (sum, c) => sum + (c.children ? scrollWidth(c.children) : (Number(c.width) || 150)), 0);
}
